import React, { memo } from 'react'
import Link from 'next/link'
import { ColumnSideNavBox } from '../column-side-nav-box'
import type { ColumnCategory } from '../../../types/newt/column'

export const ColumnSideNavCategoryList = memo(
  ({
    categories,
    categoryCounts,
  }: {
    categories: ColumnCategory[]
    categoryCounts: { [key: string]: number }
  }) => (
    <ColumnSideNavBox label={'カテゴリー'}>
      <ul className={'list-disc pl-5 grid gap-4 mt-4'}>
        {categories
          .filter((category) => categoryCounts[category._id] > 0)
          .map((category) => (
            <li key={category._id} className={'text-base'}>
              <Link
                href={`/column/categories/${category.slug}/`}
                className={'inline-flex gap-2'}
              >
                {category.name}
                <span
                  className={
                    'text-white text-bold bg-secondary rounded-[4px] px-2 font-bold leading-snug'
                  }
                >
                  {categoryCounts[category._id]}
                </span>
              </Link>
            </li>
          ))}
      </ul>
    </ColumnSideNavBox>
  )
)
ColumnSideNavCategoryList.displayName = 'ColumnSideNavCategoryList'
